module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--large@2x-31206967062934096966111e4e21f592.jpg";